export const notesEndpoints = {
  getTranscripts: '/api/grades/me',
  getTranscript: (transcriptId: number | 'current') => `/transcripts/${transcriptId}`,
  markScoresAsRead: '/scores/mark-as-read',
};
